module.exports = __webpack_public_path__ + "static/img/dMRI6.a5883305.png";